import { Location } from "../../../models/organisation/Location"

export class OnboardingFarmer {
    createdAt: string
    owner_person_id: number
    location: Location
    owner_firstname?: string
    owner_lastname?: string
    external_id?: string
    plot_name?: string

    constructor(d: any) {
        this.createdAt = d.createdAt ?? d.created_at ?? d._created_at
        this.owner_person_id = d.personId ?? d.person_id
        this.location = Location.build(d.location)
        this.external_id = d.external_id
        this.owner_firstname = d.owner_firstname
        this.owner_lastname = d.owner_lastname
        this.plot_name = d.plot_name
    }

    static buildFromBI(d: any): OnboardingFarmer {
        return new OnboardingFarmer(
            {
                ...d, location: {
                    province: d.province,
                    district: d.district,
                    subdistrict: d.provinsubdistrictce,
                    village: d.village,
                }
            })
    }
}